/**
 * Specifies Chart Themes
 */
/** @private */
export var axisLabelFont = {
    size: '12px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export var axisTitleFont = {
    size: '14px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export var chartTitleFont = {
    size: '15px',
    fontWeight: '500',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export var chartSubTitleFont = {
    size: '11px',
    fontWeight: '500',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export var crosshairLabelFont = {
    size: '13px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export var tooltipLabelFont = {
    size: '13px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export var legendLabelFont = {
    size: '13px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export var stripLineLabelFont = {
    size: '12px',
    fontWeight: 'Regular',
    color: '#353535',
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export var stockEventFont = {
    size: '13px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
